import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getRole } from '../../utils/backend';
import { CTable, CTableHead, CTableBody, CTableRow, CTableHeaderCell, CTableDataCell } from '@coreui/react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ViewRole = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [admin, setAdmin] = useState({});
    const { id } = useParams();

    useEffect(() => {
        fetchData(id);
    }, [id]);

    const fetchData = async (id) => {
        setIsLoading(true);
        try {
            const response = await getRole({ id: id });
            setAdmin(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            setAdmin({});
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackClick = () => {
        const currentPath = window.location.pathname;
        if (currentPath.includes('/details/edit/')) {
            navigate(`/roles/details/${id}`);
        } else {
            navigate('/roles');
        }
    };

    const groupPermissions = (permissions) => {
        return permissions.reduce((acc, permission) => {
            const { permission_group, permission_name } = permission;
            if (!acc[permission_group]) {
                acc[permission_group] = [];
            }
            acc[permission_group].push(permission_name);
            return acc;
        }, {});
    };

    const groupedPermissions = admin.permissions ? groupPermissions(admin.permissions) : {};

    return (
        <>
            {isLoading ? (
                <div className="card border-light">
                    <div className="card-body p-4">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <Skeleton height={20} width={150} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <Skeleton height={20} width={150} />
                            </div>
                        </div>
                        <div className="mb-3">
                            <CTable borderless striped>
                                <CTableHead>
                                   
                                </CTableHead>
                                <CTableBody>
                                    {[...Array(10)].map((_, index) => (
                                        <CTableRow key={index}>
                                            <CTableDataCell><Skeleton height={20} width={150} /></CTableDataCell>
                                            <CTableDataCell><Skeleton height={20} width={150} /></CTableDataCell>
                                        </CTableRow>
                                    ))}
                                </CTableBody>
                            </CTable>
                        </div>
                        <div className="d-flex justify-content-end">
                            <Skeleton height={40} width={100} style={{ marginRight: '10px' }} />
                            <Skeleton height={40} width={100} />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="card border-light">
                    <div className="card-body p-4">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">ID</label>
                                <p><b>{admin.id}</b></p>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Role</label>
                                <p><b>{admin.role}</b></p>
                            </div>
                        </div>
                        <div className="mb-3">
                            <CTable borderless striped>
                                <CTableHead>
                                    <CTableRow>
                                        <CTableHeaderCell scope="col">Permission Group</CTableHeaderCell>
                                        <CTableHeaderCell scope="col">Permission Name</CTableHeaderCell>
                                    </CTableRow>
                                </CTableHead>
                                <CTableBody>
                                    {Object.entries(groupedPermissions).map(([group, names], index) => (
                                        <CTableRow key={index}>
                                            <CTableDataCell>{group}</CTableDataCell>
                                            <CTableDataCell>{names.join(', ')}</CTableDataCell>
                                        </CTableRow>
                                    ))}
                                </CTableBody>
                            </CTable>
                        </div>
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn me-3 ansa-button-secondary" onClick={handleBackClick}>Back</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ViewRole;